(function ($) {
    var $el = $('[data-collapse-toggle]');
    $el.on('click', function() {
        btnTrigger($(this));
        $($(this).data('target')).collapseToggle();
    });
    $.fn.collapseToggle = function() {
        this.slideToggle('fast');
        this.focus();
    };
}(jQuery));

function btnTrigger($el) {
    $el.attr('aria-expanded', (i, attr) => {
        return attr === 'true' ? 'false' : 'true';
    });
    $($el.data('target')).attr('aria-hidden', (i, attr) => {
        return attr === 'true' ? 'false' : 'true';
    });
    if($el.attr('aria-expanded') === 'true') {
        $el.addClass('expanded');
    } else {
        $el.removeClass('expanded');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/collapse-toggle/collapse-toggle.js